// extracted by mini-css-extract-plugin
module.exports = {"surface":"NotFound_surface__38pYB","ionContent":"NotFound_ionContent__3r61i"};